import {
  Redirect,
  Route,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";

import AdminPage from "../Admin";
import EventPage from "../Event";
import HomePage from "../Home";
import NotFoundPage from "../NotFound";
import React from "react";
import useCurrentUser from "../../hooks/useCurrentUser";

const Authenticated = () => {
  const currentUser = useCurrentUser();
  const { ticket } = currentUser || {};
  const { access } = ticket || {};

  return (
    <div className="AuthenticatedPage">
      <Router>
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>
          <Route path="/admin">
            <AdminPage />
          </Route>
          <Route path="/SEAADE-IADR">
            <>
              {access && access !== "SEAADE-IADR" ? <Redirect to="/" /> : null}
              <EventPage />
            </>
          </Route>
          <Route path="/SEAADE">
            <>
              {access && !access.includes("SEAADE") ? (
                <Redirect to="/" />
              ) : null}
              <EventPage />
            </>
          </Route>
          <Route path="/IADR">
            <>
              {access && !access.includes("IADR") ? <Redirect to="/" /> : null}
              <EventPage />
            </>
          </Route>
          <Route>
            <NotFoundPage />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default Authenticated;
